export enum ShopType {
    DISTANCE = 'DISTANCE',
    RETAIL = 'RETAIL',
    WEBSHOP = 'WEBSHOP',
}
